import React from 'react'
import { AppLegendChips } from "@components"
import { dsColorNew } from "@palette"
import { repricingPass } from "@signals"
import { passDecisions, showPassDecisions } from "Pages/AnalyzersV2/@signals"
import { KIND_LABELS, KIND_META } from "../columns/Data/@services/cellDecisions"
import { toneOf } from "Pages/DsRepricing/@components/tones"

// The second group, only with a pass open and the marks on (CU-869fmm949, UX Obs. 14)
const decisionsGroup = () => {
    const anySim = (passDecisions.value?.cells || []).some(c => (c.decisions || []).some(d => d?.payload?.mode === 'dry_run'))
    return [
        ...Object.keys(KIND_META).map(kind => ({
            icon: kind === 'applied' ? 'arrow-trend-up' : KIND_META[kind].icon,
            label: kind === 'applied' ? 'Price changed (up / down)' : KIND_LABELS[kind],
            color: toneOf(KIND_META[kind].tone).fg,
        })),
        ...anySim ? [{ icon: 'flask', label: 'SIM: simulated, not sent', color: dsColorNew.noteInfo }] : [],
        { icon: 'hashtag', label: 'A number = several decisions; the icon is the most relevant', color: dsColorNew.textMuted },
    ]
}


// Under the table, as its footer: what the cell colours mean is read after the cells, not before
export default function AnalyzersLegendToolbar({ isRating = false }) {
    const text = isRating ? "Rating" : "Price"

    return <AppLegendChips
        variant="plain"
        sx={{ justifyContent: 'flex-start', mt: 1.5 }}
        groups={[[
            { icon: "droplet", label: `Cheapest ${text} in column`, color: dsColorNew.successBar },
            { icon: "droplet", label: `Most Expensive ${text} in column`, color: dsColorNew.dangerSoft },
        ], ...(!isRating && repricingPass.value && showPassDecisions.value && passDecisions.value?.cells?.length ? [decisionsGroup()] : [])]}
    />
}
